import React, { useState, useEffect } from 'react';
import {
    Accordion, AccordionSummary, Alert, LinearProgress, Modal,
    Paper, Typography, Grid, Table, TableBody, TableCell, Box,
    TableContainer, TableHead, TableRow, Checkbox, TextField,
    AccordionDetails, FormControlLabel, Badge, IconButton, Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useSelector, useDispatch } from 'react-redux';
import { CircleAlertIcon, CircleCheckBigIcon, Trash2Icon } from 'lucide-react';
import Swal from 'sweetalert2';
import {
    setCargaDatos, getConsentimiento, ReplaceTagsConsentimiento, descargarPdf,
    ReplaceTagsContrato
} from "../../Redux/V2/ContratoRedux";
import { setCargaGeneral } from "../../Redux/GeneralDuck";
import Select from 'react-select'
import InyeccionService from '../../services/inyeccionService';
import Cookies from 'universal-cookie';

const TareasEepp = ({ from }) => {
    const dispatch = useDispatch()
    //const servicios = useSelector((store) => store.contratoV2.contrato)
    //const causas = useSelector((store) => store.contratoV2.Causas)
    const tareasValidacion = useSelector((store) => store.contratoV2.TareasValidacion)
    const entrevista = useSelector((store) => store.contratoV2.Entrevista)
    const actualizacion = useSelector((store) => store.contratoV2.Actualizacion)

    const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
    const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
    const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);
    const contratoValidado = useSelector((store) => store.contratoV2.ContratoValidado);

    const cookies = new Cookies();


    const bloqueadoTotalmente =
        (contratoValidado?.validado && actualizacion?.actualizacion?.status != 1) ||
        !!contratoCancelado?.cancelado ||
        !!contratoFiniquitado?.finiquitado

    const [selectedTasks, setSelectedTasks] = useState([]); // Inicialmente vacío
    const [disabledComponent, setDisabledComponent] = useState(false);
    const [IsEEPP, setIsEEPP] = useState(false);

    /** TAREAS  en public task.js*/
    const [EEPP_TASK, setEEPP_TASK] = useState([])
    const [User_EEPP, setUser_EEPP] = useState([])

    const [validateCE, setValidateCE] = useState(false)

    useEffect(() => {
        getTareasEpp()
        setUser_EEPP(window.USER_EEPP)
    }, [])

    const getTareasEpp = async () => {
        var list = await dispatch(setCargaDatos("Tareas", "get", 11));
        setEEPP_TASK(list);
    }


    useEffect(() => {
        if (actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 1) {
            setDisabledComponent(true)
        }
        else if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
            if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
                const _objAct = actualizacion.actualizacionModelos.find(obj => obj.model == "tareasEepp");
                if (_objAct != null) {
                    const _tasks = JSON.parse(JSON.parse(_objAct.json).tasks)
                    setSelectedTasks(_tasks);
                    return
                }
            }
        }
        if (tareasValidacion?.eepp) {
            setSelectedTasks(tareasValidacion.eepp)
            setIsEEPP(tareasValidacion.eepp.length > 0)
        }

        if (actualizacion && actualizacion.actualizacion && actualizacion.actualizacion.status == 2 && actualizacion.actualizacion.type == 2) {

            if (actualizacion.actualizacion.validation != null) {
                setValidateCE(!actualizacion.actualizacion.validation)
            } else
                setValidateCE(false)
        }

    }, [tareasValidacion])

    const saveSetIsEEPP = async () => {
        if (!IsEEPP == false) { //quitar tareas eepp de bd
            var payload = {
                type: "eepp",
                contractId: entrevista.contractId,
                tasks: JSON.stringify([])
            }

            if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
                var aux = {
                    json: JSON.stringify(payload),
                    model: "tareasEepp",
                    actualizacionId: actualizacion.actualizacion.id,
                }
                var exito = await dispatch(setCargaDatos("Actualizacion", "put", aux));
                setSelectedTasks([]);
                setIsEEPP(!IsEEPP)
                return
            }

            console.log(payload)
            await dispatch(setCargaDatos("TareasValidacion", "post", payload))

        }
        setIsEEPP(!IsEEPP)
    }

    const handleCheckboxChange = (event, task) => {
        const { checked } = event.target;
        setSelectedTasks(prevTasks => {
            if (checked) {
                // Si se marca, agregar la tarea al array
                var actualizacionId = null;
                if (actualizacion?.actualizacion?.type == 2 && actualizacion?.actualizacion?.status == 2 && actualizacion?.actualizacion?.validation == false) {
                    actualizacionId = actualizacion.actualizacion.id
                }

                return [...prevTasks, { name: task.name, description: task.description, extra: "", userId: 0, ...(actualizacionId !== null && { actualizacionId }) }];
            } else {
                // Si se desmarca, eliminar del array
                return prevTasks.filter(t => t.name !== task.name);
            }
        });
    };


    const handleExtraChange = (event, taskName) => {
        const { value } = event.target;
        setSelectedTasks(prevTasks =>
            prevTasks.map(task =>
                task.name === taskName ? { ...task, extra: value } : task
            )
        );
    };


    const handleUserChange = (event, taskName) => {
        const { value } = event.target;
        setSelectedTasks(prevTasks =>
            prevTasks.map(task =>
                task.name === taskName ? { ...task, userId: Number(value) } : task
            )
        );
    };

    const saveTask = async () => {
        var payload = {
            type: "eepp",
            contractId: entrevista.contractId,
            tasks: JSON.stringify(selectedTasks)
        }

        if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
            var aux = {
                json: JSON.stringify(payload),
                model: "tareasEepp",
                actualizacionId: actualizacion.actualizacion.id,
            }
            var exito = await dispatch(setCargaDatos("Actualizacion", "put", aux));
            return
        }

        console.log(payload)
        await dispatch(setCargaDatos("TareasValidacion", "post", payload))


    }

    const tienePermisosValidacion = (() => {
        const firmado =
            contratoFirmado?.firmado === true ||
            contratoFirmado?.firmado === 'true';

        if (!firmado) return false;

        let rolId = NaN;
        try {
            const raw = cookies.get('rolId');
            if (raw != null) rolId = parseInt(raw, 10);
        } catch { /* noop */ }

        const lista = Array.isArray(window?.ROLID_VALIDA) ? window.ROLID_VALIDA : [];
        return !Number.isNaN(rolId) && lista.includes(rolId);
    })();


    const desactivar = () => {
        if (!tienePermisosValidacion) // no tienen permisos
            return true;
        if (disabledComponent)
            return true;

        if (contratoValidado?.validado) {
            if (actualizacion?.actualizacion?.type == 2 && actualizacion?.actualizacion?.status == 2 && actualizacion?.actualizacion?.validation == false) {
                return false;
            }
            return true;
        }
        return false;
    }


    return (
        <>
            {/* GESTION DE TAREAS EEPP */}
            {IsEEPP ?
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panelEepp-content" id="panelEepp-header" >
                        TAREAS DE EEPP
                    </AccordionSummary>
                    <AccordionDetails>

                        <Table>
                            {EEPP_TASK?.map((task) => {
                                const isChecked = selectedTasks.some(selected => selected.name === task.name);
                                const selectedUser = selectedTasks.find(selected => selected.name === task.name)?.userId || "";
                                const selectedExtra = selectedTasks.find(selected => selected.name === task.name)?.extra || "";

                                return (
                                    <tr key={task.name}>
                                        <td>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={isChecked}
                                                        onChange={(e) => handleCheckboxChange(e, task)}
                                                        disabled={desactivar()}
                                                    />
                                                }
                                                label={`${task.name}`}
                                            />
                                        </td>
                                        <td>{`${task.description.slice(0, 60)}...`}</td>
                                        <td style={{ paddingRight: "10px" }}>
                                            <TextField
                                                label="Comentario"
                                                value={selectedExtra}
                                                onChange={(e) => handleExtraChange(e, task.name)}
                                                variant="outlined"
                                                fullWidth
                                                size='small'
                                                disabled={desactivar() || !isChecked}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                disabled={desactivar() || !isChecked}
                                                value={selectedUser}
                                                onChange={(e) => handleUserChange(e, task.name)} >
                                                <option value="" disabled>
                                                    Seleccione Usuario
                                                </option>
                                                {User_EEPP?.map((user) => (
                                                    <option key={user.userId} value={user.userId}>
                                                        {user.Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                );
                            })}
                        </Table>
                        <Grid item xs={12} >
                            <Button variant="contained" onClick={saveTask} disabled={desactivar()}>Guardar EEpp</Button>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
                : null}
            <Button sx={{ mt: 1 }} variant='outlined' onClick={() => saveSetIsEEPP()} disabled={desactivar()}>
                {IsEEPP ? "Quitar tareas EEPP" : "Agregar tareas EEPP"}
            </Button>
        </>
    );
};

export default TareasEepp;